import _ from 'lodash';
import { RESET_APP, RESET_CART } from '../actions/index';
import {
  CLEAR_SELECTED_PARTY_ROOMS,
  RECEIVE_PARTY_ROOMS,
  SELECT_PARTY_ROOM
} from '../actions/partyRoom';

const rawInitialState = {
  partyRoomsData: null,
  selectedPartyRooms: {}
};
const initialState = () => JSON.parse(JSON.stringify(rawInitialState));

export default (state = initialState(), action) => {
  switch (action.type) {
    case CLEAR_SELECTED_PARTY_ROOMS:
      return { ...state, selectedPartyRooms: {} };
    case RECEIVE_PARTY_ROOMS:
      return { ...state, partyRoomsData: action.partyRooms };
    case RESET_CART:
    case RESET_APP:
      return { ...initialState() };
    case SELECT_PARTY_ROOM:
      const newSelected = _.cloneDeep(state.selectedPartyRooms);
      let newSelectedTimeslot = newSelected[action.timeslotId];
      if (action.quantity > 0) { 
        // Party room item was added/upped
        if (newSelectedTimeslot === undefined ) {
          newSelected[action.timeslotId] = {};
          newSelectedTimeslot = newSelected[action.timeslotId];
          if (newSelectedTimeslot) {
            newSelectedTimeslot[action.partyRoomId] = action.quantity;
          }
        }
        else {
          newSelectedTimeslot[action.partyRoomId] = action.quantity;
        }
      } else {
        // Party room item was removed
        if (newSelectedTimeslot[action.partyRoomId] !== undefined) delete newSelectedTimeslot[action.partyRoomId];
        if (newSelected !== undefined && newSelected[action.timeslotId] !== undefined) {
          delete newSelected[action.timeslotId];
        }
      }
      return { ...state, selectedPartyRooms: newSelected };
    default:
      return state;
  }

};
